import { observer } from 'mobx-react-lite'
import { PageNumberInfo } from 'shared/ui/PageNumberInfo/PageNumberInfo'
import { UpgradeHeader } from 'pages/settings/pages/billing/pages/upgrade/ui/UpgradeHeader/UpgradeHeader'
import { PlanContainer } from 'pages/settings/ui/BillingPlan'
import { useBillingUpgradePageContext } from 'pages/settings/pages/billing/pages/upgrade/context/upgradeContext'
import styles from './styles.module.scss'

export const UpgradeFirstPage = observer(() => {
  const store = useBillingUpgradePageContext()
  const {
    currentStep,
    totalSteps,
    plans,
    selectedValues,
    period,
    additionalSeatPrice,
    additionalNumbersPrice,
    handleSetPeriod,
    setSelectedValue,
    isDowngrade,
  } = store

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <PageNumberInfo
          currentStep={currentStep}
          totalSteps={totalSteps}
          title={isDowngrade ? 'Downgrade' : 'Upgrade'}
        />
        <UpgradeHeader period={period} handleSetPeriod={handleSetPeriod} />
      </div>
      <div className={styles.plansContainer}>
        {plans.map((plan) => (
          <PlanContainer
            key={plan.name}
            plan={plan}
            additionalNumberPrice={additionalNumbersPrice}
            additionalSeatPrice={additionalSeatPrice}
            className={styles.plan}
            selectedValue={selectedValues[plan.name]}
            onSelectValue={(value, item) => {
              setSelectedValue(plan.name, String(value))
              plan.onSelectValue(value, item)
            }}
          />
        ))}
      </div>
    </div>
  )
})
